import { render, staticRenderFns } from "./Help_Collapse.vue?vue&type=template&id=8ccd3684&scoped=true&"
import script from "./Help_Collapse.vue?vue&type=script&lang=js&"
export * from "./Help_Collapse.vue?vue&type=script&lang=js&"
import style0 from "./Help_Collapse.vue?vue&type=style&index=0&id=8ccd3684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccd3684",
  null
  
)

export default component.exports